export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0032s_0000_Black-&-White-29.2a2cd803.png";